import React from "react";
import { Router } from "./components";
import './globalStyles.css'
export default function App() {
  return (
    <div className="App">
      <Router />
    </div>
  );
}